export type RedirectPayload = [string, string] | [];
export type RedirectionUrlState = {
    cryptoText: string;
}

const isRedirectUrlState = (obj: any): obj is RedirectionUrlState => {
    return typeof (obj?.cryptoText ?? undefined) == "string";
}

export const RedirectionHelpers = Object.freeze({
    redirectionKey: "redirection",
    isRedirectUrlState
})